var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(this.component,{tag:"v-component",attrs:{"value":_vm.value,"multiple":_vm.multiple,"items":_vm.items},on:{"input":function (v) { return _vm.$emit('input', v); }}})}
var staticRenderFns = []

export { render, staticRenderFns }